/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import i18n from 'src/localization/i18n';
import { Brand } from 'src/types';
import {
  CREATE_NEW_MESSAGE_FROM_FAQ,
  DOCUMENT_CENTER_FROM_FAQ,
  PAPERLESS_NOTIFICATIONS_PATH,
  PROFILE_PATH,
} from 'src/constants/routePaths';
import {
  FAQComponentItem,
  FAQComponentItemList,
  FAQComponentItemParagraph,
  FAQComponentItemParagraphWithLinks,
  FAQComponentItemTextWithLinks,
  FAQComponentProps,
  FAQComponentSection,
  FAQComponentWithLinksProps,
  LinkType,
  resourceKey,
} from './FAQComponent';
import * as rk from '../../../localization/resourceKeys';

/// @ts-ignore
import thirdPartyAuthorizationAudi from '../../../assets/pdfs/faq/ThirdPartyAuthorization-Audi.pdf';
// @ts-ignore
import thirdPartyAuthorizationVW from '../../../assets/pdfs/faq/ThirdPartyAuthorization-VW.pdf';

const BalloonFAQ: React.FC<Omit<FAQComponentProps, 'accountType'>> = ({ brand }) => {
  const styleBrand = brand === Brand.AUDI ? Brand.AUDI : Brand.VW;
  const messageCenterUrl = CREATE_NEW_MESSAGE_FROM_FAQ;
  const documentCenterUrl = DOCUMENT_CENTER_FROM_FAQ;
  const paperlessNotificationUrl = PAPERLESS_NOTIFICATIONS_PATH;
  const accountSettingsUrl = PROFILE_PATH;
  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
  return (
    <div className='c-faq u-pv u-ph' role='main'>
      <h4 className='header'>{i18n.t(rk.FAQ_TITLE) as string}</h4>
      <div>
        <FAQComponentSection className='u-mb' value={i18n.t(rk.FAQ_BALLOON_MOST_COMMON_QUESTIONS_SECTION)}>
          {/** FAQ 1 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION1_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 2 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_BALLOON_NEW_QUESTION2_ANSWER1', styleBrand)} />
            <FAQComponentItemList
              items={[
                i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM1),
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM2),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_MESSAGECENTER_LINK),
                      value: messageCenterUrl as string,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM3),
                i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM4),
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM5),
                  links: [
                    {
                      key: i18n.t(rk.DOCUMENT_CENTER_TITLE),
                      value: documentCenterUrl as string,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM6),
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM7),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_ANSWER1_LISTITEM7_LINK1),
                      value: paperlessNotificationUrl as string,
                      type: LinkType.NavLink,
                    },
                    {
                      key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 3 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION3_ANSWER1_PARAGRAPH3)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION1_ANSWER1_PARAGRAPH2)} />
          </FAQComponentItem>
          {/* FAQ 4 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH1_LINK1),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH2)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH3)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH4_CONTENT)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH5)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH6)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION4_ANSWER1_PARAGRAPH7)} />
          </FAQComponentItem>
          {/* FAQ 5 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION5)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION5_ANSWER1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 6 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION6)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_MOVING_ANSWER1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_MOVING_ANSWER1_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION2_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 7 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION7)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION7_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION7_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Titles section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_TITLES)}>
          {/* FAQ 8 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION1)}>
            {process.env.REACT_APP_TITLE_RELEASE_FLAG === 'true' && (
              <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER1_BCO_PARAGRAPH1)} />
            )}
            {process.env.REACT_APP_TITLE_RELEASE_FLAG === 'true' && (
              <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER1_BCO_PARAGRAPH2)} bold />
            )}
            {process.env.REACT_APP_TITLE_RELEASE_FLAG === 'false' && (
              <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER1_PARAGRAPH1)} />
            )}
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_TITLES_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Payments section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_PAYMENTS_SECTION)}>
          {/* FAQ 9 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION9)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION9_ANSWER1_PARAGRAPH1)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION9_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.DOCUMENT_CENTER_TITLE),
                  value: documentCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 10 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION10)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION10_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION10_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 11 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION11)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION11_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 12 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_PAYMENTOPTIONS_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER1_LINK1),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH2', styleBrand)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH3', styleBrand)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH4', styleBrand)} />
          </FAQComponentItem>
          {/* FAQ 13 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION1)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION1_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemList
              items={[
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION1_ANSWER1_PARAGRAPH2),
                  links: [
                    {
                      key: capitalize(i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_ENROLL_IN_AUTOPAY)),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION1_ANSWER1_PARAGRAPH3),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_HOMEPAGE_LINK),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                resourceKey('FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION1_ANSWER1_PARAGRAPH4', styleBrand),
              ]}
            />
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH3', styleBrand)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH4', styleBrand)} />
          </FAQComponentItem>
          {/* FAQ 14 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_PAYMENT_OPTIONS_QUESTION2_ANSWER1_PARAGRAPH1)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER1_PARAGRAPH3', styleBrand)} />
            <FAQComponentItemParagraph
              value={resourceKey('FAQ_BALLOON_PAYMENT_OPTIONS_ANSWER1_PARAGRAPH4', styleBrand)}
            />
          </FAQComponentItem>
          {/* FAQ 15 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION1_ANSWER1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 16 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION3_ANSWER1_PARAGRAPH3)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_QUESTION1_ANSWER1_PARAGRAPH2)} />
          </FAQComponentItem>
          {/* FAQ 17 */}
          <FAQComponentItem value={resourceKey('FAQ_PAYMENTOPTIONS_QUESTION4', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER4_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 18 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION2)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_PAYMENT_OPTIONS_QUESTION2_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_PAYMENT_OPTIONS_QUESTION3_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_PAYMENT_OPTIONS_QUESTION3_ANSWER1_PARAGRAPH2_LINK) as string,
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* Account management section */}
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_SECTION)}>
          {/* FAQ 19 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION1_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1),
                  value: documentCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 20 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION7)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION7_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION7_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 21 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION2)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_LEASE_NEW_QUESTION2_ANSWER1', styleBrand)} />
            <FAQComponentItemList
              items={[
                i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM1),
                {
                  value: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM2),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                      value: messageCenterUrl as string,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM3),
                i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM4),
                {
                  value: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1),
                      value: documentCenterUrl as string,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM6),
                {
                  value: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM7),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM7_LINK1),
                      value: paperlessNotificationUrl as string,
                      type: LinkType.NavLink,
                    },
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 22 */}
          <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION2', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION2_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 23 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_PAPERLESSBILLING_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION3_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 24 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH1_LINK1),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH2_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH4)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH5)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH6)} />
          </FAQComponentItem>
          {/* FAQ 25 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION5)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION5_ANSWER1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 26 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_PAPERLESSBILLING_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_PAPERLESSBILLING_ANSWER4_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK1),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK1),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK2),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK2),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK3),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK3),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK5),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK5),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK6),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK6),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK7),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK7),
                  type: LinkType.Email,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION4_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 27 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_ACCOUNT_MANAGEMENT_QUESTION1)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_NEW_ACCOUNT_MANAGEMENT_QUESTION1_ANSWER1)} />
          </FAQComponentItem>
          {/* FAQ 28 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION5)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION5_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION5_ANSWER1_PARAGRAPH2)}
            />
          </FAQComponentItem>
          {/* FAQ 29 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_THIRDPARTYAUTHORIZATION_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_THIRDPARTYAUTHORIZATION_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_THIRDPARTYAUTHORIZATION_ANSWER1_LINK1),
                  value: brand === Brand.AUDI ? thirdPartyAuthorizationAudi : thirdPartyAuthorizationVW,
                  type: LinkType.NewPage,
                },
                {
                  key: i18n.t(rk.FAQ_THIRDPARTYAUTHORIZATION_ANSWER1_LINK2),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 30 */}
          <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION6', styleBrand)}>
            <FAQComponentItemParagraph
              value={resourceKey('FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION6_ANSWER1_PARAGRAPH1', styleBrand)}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* End of Contracts section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_SECTION)}>
          {/* FAQ 31 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH1)}
            />

            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH2)}
            />
            <FAQComponentItemList
              items={[
                {
                  value: i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_LISTITEM1),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_LINK1),
                      value: i18n.t(
                        brand === Brand.AUDI
                          ? 'https://www.audiusa.com/en/shopping-tools/financial-services-hub/lease-or-finance/lease-transition-options/'
                          : 'https://www.vw.com/en/financial-services/lease-transition-options.html'
                      ),
                      type: LinkType.NewPage,
                    },
                  ],
                } as FAQComponentWithLinksProps,
              ]}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH3)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH2)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH3)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH4)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH5)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH6)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH6)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH7)}
            />
          </FAQComponentItem>
          {/* FAQ 32 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH2)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH3)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION2_ANSWER1_PARAGRAPH4)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION1_ANSWER1_PARAGRAPH5)}
            />
          </FAQComponentItem>
          {/* FAQ 33 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION3)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION3_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION3_ANSWER1_PARAGRAPH2)}
            />
          </FAQComponentItem>
          {/* FAQ 34 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION5)}>
            <FAQComponentItemParagraph
              value={resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_PARAGRAPH1', styleBrand)}
            />
            <FAQComponentItemList
              items={[
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM1', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM2', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM3', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM4', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM5', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM6', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM7', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM8', styleBrand),
                resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER1_LISTITEM9', styleBrand),
              ]}
            />
            <FAQComponentItemTextWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_END_OF_CONTRACT_QUESTION5_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_BALLOON_NEW_QUESTION_WEARANDUSEGUIDELINES_LINK),
                  value: i18n.t(
                    brand === Brand.AUDI
                      ? 'https://www.audiusa.com/us/web/en/shopping-tools/financial-services-hub/lease-or-finance/turn-in-process.html'
                      : 'https://www.vw.com/en/financial-services/lease-transition-options/turn-in-process.html'
                  ),
                  type: LinkType.NewPage,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 35 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_TURNINSETTLEMENTINVOICE_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER3_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(
                    brand === Brand.AUDI
                      ? rk.FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER3_LINK1_AUDI
                      : rk.FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER3_LINK1_VW
                  ),
                  value: i18n.t(
                    brand === Brand.AUDI
                      ? rk.FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER3_LINK1_AUDI
                      : rk.FAQ_LEASE_TURNINSETTLEMENTINVOICE_ANSWER3_LINK1_VW
                  ),
                  type: LinkType.Email,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 36 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_LEASEEND_QUESTION2)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_NEW_LEASEEND_QUESTION2_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: resourceKey('FAQ_LEASE_NEW_LEASEEND_QUESTION2_ANSWER1_PARAGRAPH1_LINK1', styleBrand),
                  value:
                    brand === Brand.AUDI
                      ? 'https://www.audiusa.com/us/web/en/shopping-tools/financial-services-hub/lease-or-finance/lease-transition-options.html'
                      : 'https://www.vw.com/en/financial-services/lease-transition-options.html',
                  type: LinkType.NewPage,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_LEASEEND_QUESTION2_ANSWER1_PARAGRAPH2)} />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Special situations section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_SECTION)}>
          {/* FAQ 37 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_ACCIDENT_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_ACCIDENT_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_SPECIAL_SITUATIONS_QUESTION1_ANSWER1_PARAGRAPH4)}
            />
            <FAQComponentItemParagraph value={resourceKey('FAQ_ACCIDENT_ANSWER1_PARAGRAPH3', styleBrand)} />
          </FAQComponentItem>
          {/* FA 38 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_MOVING_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_MOVING_ANSWER1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_MOVING_ANSWER1_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 39 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_SCRA_QUESTION1)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH1', styleBrand)} />
            <FAQComponentItemList
              items={[
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM1', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM2', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM3', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM4', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM5', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM6', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM7', styleBrand),
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH2', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_SCRA_ANSWER1_LINK1),
                  value: 'https://legalassistance.law.af.mil/',
                  type: LinkType.NewPage,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH3', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_ANSWER1_PARAGRAPH1)}
            />
            <ul>
              <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM1) as string}</li>
              <li>
                <FAQComponentItemTextWithLinks
                  value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM2)}
                  links={[
                    {
                      key: 'https://scra.dmdc.osd.mil',
                      value: 'https://scra.dmdc.osd.mil',
                      type: LinkType.NewPage,
                    },
                  ]}
                />
              </li>
              <li>
                {i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM3) as string}
                <ul>
                  <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3_EXTRA_1) as string}</li>
                  <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3_EXTRA_2) as string}</li>
                </ul>
              </li>
            </ul>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_ANSWER1_PARAGRAPH2)}
            />
            <FAQComponentItemList
              items={[
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM1),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM2),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM4),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM5),
                i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM16),
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 40 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TRANSFERMYACCOUNT_QUESTION1)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_TRANSFERMYACCOUNT_ANSWER1_PARAGRAPH1', styleBrand)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_TRANSFERMYACCOUNT_ANSWER1_PARAGRAPH2', styleBrand)} />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_TRANSFERMYACCOUNT_ANSWER1_PARAGRAPH3', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 41 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION2)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_CONSUMERCREDIT_ANSWER1_PARAGRAPH1', styleBrand)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_CONSUMERCREDIT_ANSWER1_PARAGRAPH2', styleBrand)} />
          </FAQComponentItem>
          {/* FAQ 42 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION50)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION3_ANSWER1_LISTITEM1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_SPECIALSITUATIONS_ANSWER42_LISTITEM2)} />
            <FAQComponentItemList items={[i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM3)]} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_BALLOON_SPECIALSITUATIONS_ANSWER42_LISTITEM3)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH2)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_BALLOON_NEW_SPECIALSITUATIONS_QUESTION3_ANSWER1_PARAGRAPH3)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK) as string,
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 43 */}
          <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4', styleBrand)}>
            <FAQComponentItemParagraph
              value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4_ANSWER1_PARAGRAPH1', styleBrand)}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4_ANSWER1_PARAGRAPH2', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Disaster relief section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_SECTION)}>
          {/* FAQ 44 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION1_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 45 */}
          <FAQComponentItem value={resourceKey('FAQ_PAYMENTOPTIONS_QUESTION4', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER4_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 46  */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION2)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION2_ANSWER1_PARAGRAPH1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION2_ANSWER1_PARAGRAPH2)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION2_ANSWER1_PARAGRAPH3)} />
          </FAQComponentItem>
          {/* FAQ 47  */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION3_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION3_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph value={resourceKey('FAQ_ACCIDENT_ANSWER1_PARAGRAPH3', styleBrand)} />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Insurance and vehicle protection section */}
        <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_SECTION)}>
          {/* FAQ 48 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION1)}>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_BALLOON_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION1_ANSWER1_PARAGRAPH1)}
            />
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_BALLOON_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION1_ANSWER1_PARAGRAPH2',
                styleBrand
              )}
            />
          </FAQComponentItem>
          {/* FAQ 49 */}
          <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2', styleBrand)}>
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH1',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              small
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH2',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH3',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH4',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH5',
                styleBrand
              )}
            />
          </FAQComponentItem>
          {/* FAQ 50 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3_ANSWER1_PARAGRAPH1',
                styleBrand
              )}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3_ANSWER1_PARAGRAPH1_LINK1),
                  value: i18n.t(
                    brand === Brand.AUDI
                      ? 'https://www.audiusa.com/us/web/en/shopping-tools/dealer-search.html'
                      : 'https://www.vw.com/en/dealer-search.html?---=%7B%22dealer-search_featureappsection%22%3A%22%2F%22%7D'
                  ),
                  type: LinkType.NewPage,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {/* Wells fargo section */}
        {process.env.REACT_APP_SHOW_WF_QUESTIONS === 'true' && (
          <FAQComponentSection value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_SECTION)} dataTestId='wf-faq'>
            {/* FAQ 51 */}
            <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION1', styleBrand)}>
              <FAQComponentItemParagraph
                value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION1_ANSWER1_PARAGRAPH1', styleBrand)}
              />
            </FAQComponentItem>
            {/* FAQ 52 */}
            <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2', styleBrand)}>
              <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1)} />
              <FAQComponentItemList
                items={[
                  resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1_LISTITEM1', styleBrand),
                  {
                    value: resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1_LISTITEM2', styleBrand),
                    links: [
                      {
                        key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK1),
                        value:
                          'https://connect.secure.wellsfargo.com/auth/login/present?origin=cob&LOB=CONS&_gl=1*sfe2rf*_ga*MTQ1NjY2MjQyOC4xNzI5NjI0Njk3*_ga_7JXJJ2JF12*MTczMjIwOTY5OC45LjAuMTczMjIwOTY5OC42MC4wLjA.',
                        type: LinkType.NewPage,
                      },
                      {
                        key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK2),
                        value: 'https://www.wellsfargo.com/mobile-online-banking/apps/',
                        type: LinkType.NewPage,
                      },
                    ],
                  },
                ]}
              />
              <FAQComponentItemParagraph value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2)} />
              <FAQComponentItemList
                items={[
                  i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2_LISTITEM1),
                  resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2_LISTITEM2', styleBrand),
                ]}
              />
            </FAQComponentItem>
            {/* FAQ 53 */}
            <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3)}>
              <FAQComponentItemParagraph
                value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH1', styleBrand)}
              />
              <FAQComponentItemParagraphWithLinks
                value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2)}
                links={[
                  {
                    key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK1),
                    value:
                      'https://connect.secure.wellsfargo.com/auth/login/present?origin=cob&LOB=CONS&_gl=1*sfe2rf*_ga*MTQ1NjY2MjQyOC4xNzI5NjI0Njk3*_ga_7JXJJ2JF12*MTczMjIwOTY5OC45LjAuMTczMjIwOTY5OC42MC4wLjA.',
                    type: LinkType.NewPage,
                  },
                  {
                    key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK2),
                    value: 'https://www.wellsfargo.com/mobile-online-banking/apps/',
                    type: LinkType.NewPage,
                  },
                ]}
              />
            </FAQComponentItem>
          </FAQComponentSection>
        )}
      </div>
    </div>
  );
};

export default BalloonFAQ;
